export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const { $log } = nuxtApp
    $log('plugins:appMounted')
  })
})
